export const PAGE_OPTION = [10, 50, 100, 200, 500];

export const LOAI_PHAN_ANH = [
    { value: 1, name: "Y tế" },
    { value: 2, name: "Công an" },
    { value: 3, name: "Công thương" },
    { value: 4, name: "Giao thông vận tải" },
    { value: 5, name: "Lĩnh vực khác" },
    { value: 6, name: "Thông tin và truyền thông" },
    { value: 7, name: "Tài nguyên và môi trường" },
    { value: 8, name: "Văn hóa, thể thao Du lịch" }
]

export const XTENANT = [
    { value: "82001", name: "nbac", ten: "Trường Cao đẳng Nam Bộ" },
    { value: "83001", name: "dongkhoi_bte", ten: "Trường Cao đẳng Đồng Khởi Bến Tre" },
    { value: "83002", name: "caodang_bte", ten: "Trường Cao đẳng Bến Tre" },
    { value: "83003", name: "congnghe_bte", ten: "Trường Trung cấp Công nghệ Bến Tre" },
    { value: "27001", name: "kinhtekythuat_bnh", ten: "Trường Trung Cấp Kinh Tế Kĩ Thuật Bắc Ninh" },
    { value: "27002", name: "ytetrunguong_bnh", ten: "Trường Trung cấp Y tế Trung Ương" },
    { value: "27003", name: "caodangcongnghiep_bnh" },
    { value: "87001", name: "hongngu_dtp", ten: "Trường GDNN Hồng Ngự" },
    { value: "87002", name: "dtp_tcthapmuoi", ten: "Trung Cấp Tháp Mười" },
    { value: "87003", name: "dtp_tcthanhbinh", ten: "Trung Cấp Thanh Bình" },
    { value: "87004", name: "chauthanh_dtp", ten: "Trường GDNN Châu Thành" },
    { value: "87005", name: "laivung_dtp", ten: "Trường GDNN Lai Vung" },
    { value: "87006", name: "tanhong_dtp", ten: "Trường GDNN Tân Hồng" },
    { value: "87007", name: "lapvo_dtp", ten: "Trường GDNN Lấp Vò" },
    { value: "87008", name: "tamnong_dtp", ten: "Trường GDNN Tam Nông" },
    { value: "87009", name: "caolanh_dtp", ten: "Trường GDNN Cao Lãnh" },
    { value: "49001", name: "qnm", ten: "Trường GDNN Quảng Nam" },
    { value: "20001", name: "lsn", ten: "Trường GDNN Lạng Sơn" },
    { value: "08001", name: "tqg", ten: "Trường GDNN Tuyên Quang" },
    { value: "94001", name: "stg", ten: "Trường GDNN Sóc Trăng", tenTiengAnh: "Truong GDNN Soc Trang" },
    { value: "75001", name: "dni", ten: "Trường GDNN Đồng Nai" },
    { value: "80001", name: "lan", ten: "Trường GDNN Long An" },
    { value: "56001", name: "kha", ten: "Trường GDNN Khánh Hòa" },
    { value: "19001", name: "tnn", ten: "Trường GDNN Thái Nguyên" },
    { value: "93001", name: "hgi", ten: "Trường GDNN Hậu Giang" },
    { value: "04001", name: "cbg_trungcapnghe" },
    { value: "04002", name: "cbg_nguyenbinh" },
    { value: "04003", name: "cbg_halang" },
    { value: "04004", name: "cbg_quanghoa" },
    { value: "04005", name: "cbg_thachan" },
    { value: "04006", name: "cbg_trungkhanh" },
    { value: "04007", name: "cbg_baolac" },
    { value: "04008", name: "cbg_baolam" },
    { value: "04009", name: "cbg_hoaan" },
    { value: "04010", name: "cbg_haquang" },
    { value: "04011", name: "cbg_hocyen" },
    { value: "04012", name: "cbg_nongdan" },
    { value: "04013", name: "cbg_sathachlaixe" },
    { value: "04014", name: "cbg_caodangsupham" },
    { value: "35001", name: "hnm_demo" },
    { value: "10001", name: "lci" },
    { value: "58001", name: "ntn_trungcapyte", ten: "Trường Trung cấp Y tế Ninh Thuận" },
    { value: "75001", name: "dni" },
    { value: "17001", name: "hbh_caodangkythuatcongnghe", ten: "Trường Cao Đẳng Kỹ Thuật Hòa Bình" },
    { value: "91001", name: "kgg_trungcapkythuatnghiepvu_edu_job" },
]

export const KY_MUC_TIEU_BDG = [
    { value: "SAU_THANG_DAU_NAM", name: "6 tháng đầu năm" },
    { value: "SAU_THANG_CUOI_NAM", name: "6 tháng cuối năm" },
]

export const LOAI_VAN_BANG = [
    { value: 1, name: "Bằng tốt nghiệp cao đẳng" },
    { value: 2, name: "Chứng chỉ" },
    { value: 3, name: "Bằng tốt nghiệp trung cấp" },
    { value: 4, name: "Giấy chứng nhận GDNN" },
]

export const CAP_DON_VI_BTXH = [
    {
        "id_cap_bac_don_vi": 1,
        "ten_cap_bac_don_vi": "Cấp tỉnh"
    },
    {
        "id_cap_bac_don_vi": 2,
        "ten_cap_bac_don_vi": "Cấp huyện"
    },
    {
        "id_cap_bac_don_vi": 3,
        "ten_cap_bac_don_vi": "Cấp xã"
    },
    {
        "id_cap_bac_don_vi": 9,
        "ten_cap_bac_don_vi": "Cấp ấp/khu vực"
    }
]

export const TRANG_THAI_NCC = [
    { value: 0, name: "Chờ tiếp nhận" },
    { value: 1, name: "Chờ duyệt và ký số" },
    { value: 2, name: "Đã duyệt" },
    { value: 3, name: "Từ chối" },
    { value: 4, name: "Đã ký số" },
    { value: 5, name: "Hết hạn ký số" },
]

export const LOAI_CAN_BO = [
    { value: "1", name: "Trong nước" },
    { value: "2", name: "Ngoài nước" },
]

export const CAP_QUAN_LY_MATUY = [
    { value: 1, name: "Cấp tỉnh" },
    { value: 2, name: "Cấp huyện" },
    { value: 3, name: "Cấp xã" },
]

export const LOAI_LIEN_KET = [
    { value: "0", name: "Giáo viên" },
    { value: "1", name: "Cán bộ quản lý" },
]

export const LOAI_BAO_CAO = [
    { value: "1", name: "Mẫu 3.1" },
    { value: "2", name: "Mẫu 3.2" },
    { value: "3", name: "Mẫu 3.4 -> 3.10" },
]

export const LOAI_BAO_CAO_GLI = [
    { value: "1", name: "Mẫu 3.1" },
    { value: "2", name: "Mẫu 3.2" },
    { value: "4", name: "Mẫu 3.4" }
]

export const LOAI_BAO_CAO_GLI_3 = [
    { value: "1", name: "Mẫu 3.1" },
    { value: "2", name: "Mẫu 3.2" },
    { value: "7", name: "Mẫu 3.7" }
]

export const LOAI_BAO_CAO_GLI_4 = [
    { value: "1", name: "Mẫu 3.1" },
    { value: "2", name: "Mẫu 3.2" },
    { value: "8", name: "Mẫu 3.8" }
]

// Danh sách loại báo cáo cho hộ giai đoạn 2026-2030: Mẫu 3.1, 3.2 + Phiếu B1 (Mẫu 2.2).
export const LOAI_BAO_CAO_2026_2030 = [
    { value: "9", name: "Mẫu số 2.2: Phiếu B1 - Đánh giá, chấm điểm Đ của hộ gia đình" },
    { value: "2", name: "Mẫu số 2.3: Phiếu B2 - Thông tin thiếu hụt các dịch vụ xã hội cơ bản của hộ gia đình" },
    { value: "1", name: "Mẫu số 2.4: Phiếu C - Tổng hợp thông tin chung về hộ gia đình" }
    
]

export const CAP_VIEC_LAM = [
    { value: "TTP", name: "Cấp tỉnh" },
    { value: "QH", name: "Cấp huyện" },
    { value: "TW", name: "Cấp Trung Ương" },
]

export const HINH_THUC_LAM_VIEC = [
    { value: 0, name: "Bán thời gian" },
    { value: 1, name: "Toàn thời gian" },
]

export const PHAN_LOAI = [
    { value: 1, name: "Giám đốc/Chủ doanh nghiệp" },
    { value: 2, name: "Hợp tác xã" },
]

export const TRANG_THAI_BDG = [
    { value: 1, name: "Đi làm" },
    { value: 2, name: "Tự kinh doanh" },
    { value: 3, name: "Đã nghỉ" },
]

export const STATUS_ATVSLD = [
    { value: 0, name: "Chờ phê duyệt" },
    { value: 1, name: "Đã phê duyệt" },
]

export const TRANG_THAI = [
    { value: "DL", name: "Đi làm" },
    { value: "TKD", name: "Tự kinh doanh" },
    { value: "DN", name: "Đã nghỉ" }
]

export const TRANG_THAI_KHIEU_NAI = [
    { value: 1, name: "Chờ xử lý" },
    { value: 2, name: "Đang xử lý" },
    { value: 3, name: "Đã xử lý" }
]

export const VAI_TRO = [
    { value: 1, name: "Cán bộ chủ trì" },
    { value: 2, name: "Cán bộ thư ký" },
    { value: 3, name: "Cán bộ tham gia khác" }
]

export const STATUS_NNNLDTVN = [
    { value: 2, name: "Chưa xử lý" },
    { value: 4, name: "Đã tiếp nhận" },
    { value: 5, name: "Cần xử lý" },
    { value: 6, name: "Đã xử lý" },
]
export const HOC_KY = [
    { value: "1", name: "HK 1" },
    { value: "2", name: "HK 2" },
    { value: "3", name: "HK 3" },
    { value: "4", name: "HK 4" },
    { value: "5", name: "HK 5" },
    { value: "6", name: "HK 6" }
]

export const MAU_BAO_CAO = [
    { value: 1, name: "Mẫu báo cáo 1" },
    { value: 2, name: "Mẫu báo cáo 2" },
    { value: 3, name: "Mẫu báo cáo 3" },
    { value: 4, name: "Mẫu báo cáo 4" },
]

export const BAC_CHUYEN_MON = [
    { value: 0, name: "Trung cấp" },
    { value: 1, name: "Cao đẳng" },
    { value: 2, name: "Đại học" },
    { value: 3, name: "Thạc sĩ" },
    { value: 4, name: "Tiến sĩ" },
    { value: 5, name: "Phó giáo sư" },
    { value: 6, name: "Giáo sư" },
]

export const BAC_NGOAI_NGU = [
    { value: 0, name: "Bậc 1/A1" },
    { value: 1, name: "Bậc 2/A2" },
    { value: 2, name: "Bậc 3/B1" },
    { value: 3, name: "Bậc 4/B2" },
    { value: 4, name: "Bậc 5/C1" },
    { value: 5, name: "Bậc 6/C2" },
]

export const BAC_TIN_HOC = [
    { value: 0, name: "Bậc 1/Hiểu biết về CNTT cơ bản" },
    { value: 1, name: "Bậc 2/Sử dụng máy tính cơ bản" },
    { value: 2, name: "Bậc 3/Xử lý văn bản cơ bản" },
    { value: 3, name: "Bậc 4/Sử dụng bảng tính cơ bản" },
    { value: 4, name: "Bậc 5/Sử dụng trình chiếu cơ bản" },
    { value: 5, name: "Bậc 6/Sử dụng Internet cơ bản" },
    { value: 6, name: "Bậc 7/Xử lý văn bản nâng cao" },
    { value: 7, name: "Bậc 8/Sử dụng bảng tính nâng cao" },
    { value: 8, name: "Bậc 9/Sử dụng trình chiếu nâng cao" },
    { value: 9, name: "Bậc 10/Sử dụng hệ quản trị cơ sở dữ liệu" },
    { value: 10, name: "Bậc 11/Thiết kế đồ họa hai chiều" },
    { value: 11, name: "Bậc 12/Biên tập ảnh" },
    { value: 12, name: "Bậc 13/Biên tập trang thông tin điện tử" },
    { value: 13, name: "Bậc 14/ An toàn, bảo mật thông tin" },
    { value: 14, name: "Bậc 15/ Sử dụng phần mềm kế hoạch dự án" },
]

export const BAC_CHINH_TRI = [
    { value: 0, name: "Sơ cấp" },
    { value: 1, name: "Trung cấp" },
    { value: 2, name: "Cao cấp" },
]

export const LOAI_TIEN = [
    { value: 0, name: "Cao đẳng" },
    { value: 1, name: "Trung cấp" },
    { value: 2, name: "Sơ cấp" },
    { value: 3, name: "Lệ phí thi" },
]

export const LOAI_HOA_DON = [
    { value: 0, name: "Hóa đơn học phí theo tháng" },
    { value: 1, name: "Hóa đơn học phí theo tín chỉ" },
    { value: 2, name: "Hóa đơn lệ phí" },
]

export const HINH_THUC_DONG_HOC_PHI = [
    { value: 0, name: "Thanh toán tiền mặt" },
    { value: 2, name: "Thanh toán qua ngân hàng" },
    { value: 1, name: "Thanh toán VNPTPay" },
]

export const LOAI_THI = [
    { value: 0, name: "Thi kết thúc môn học" },
    { value: 1, name: "Thi lại" },
    { value: 2, name: "Thi học lại" },
    { value: 3, name: "Thi lại học lại" },
]

export const LOAI_MON = [
    { value: 0, name: "Môn học chung" },
    { value: 1, name: "Môn học bắt buộc" },
    { value: 2, name: "Môn học tự chọn" },
]

export const TRANG_THAI_TIEM = [
    { value: 1, name: "Đã lên lịch tiêm lần 1" },
    { value: 2, name: "Đã tiêm lần 1" },
    { value: 3, name: "Phản ứng phụ" },
    { value: 5, name: "Đã tiêm lần 2" },
    { value: 6, name: "Phản ứng phụ lần tiêm 2" },
    { value: 7, name: "Hoàn tất tiêm" },
]

export const CHUC_DANH = [
    { value: 1, name: "Hiệu trưởng" },
    { value: 2, name: "Phó hiệu trưởng" },
    { value: 3, name: "Trưởng phòng" },
    { value: 4, name: "Phó trưởng phòng" },
    { value: 5, name: "Giám đốc" },
    { value: 6, name: "Phó giám đốc" },
    { value: 7, name: "Giảng viên" },
    { value: 8, name: "Chuyên viên" },
    { value: 9, name: "Kế toán viên" },
    { value: 10, name: "Nhân viên" },
    { value: 11, name: "Nhân viên thư viện" },
    { value: 12, name: "Lái xe" },
    { value: 13, name: "Bảo vệ" },
]

export const HE_DAO_TAO = [
    { value: 0, name: "Chính quy" },
    { value: 1, name: "Giáo dục nghề nghiệp" },
]

export const TRINH_DO_VAN_HOA = [
    { value: 0, name: "Tốt nghiệp THPT" },
    { value: 1, name: "Tốt nghiệp THCS" },
    { value: 2, name: "Tốt nghiệp Trung Cấp" },
    { value: 3, name: "Tốt nghiệp Cao Đẳng" },
    { value: 4, name: "Tốt nghiệp Đại Học" },
]

export const KIEN_THUC_YEU_CAU = [
    { value: 1, name: "TN THPT QG" },
    { value: 2, name: "TN VHPT TCCN" },
    { value: 3, name: "TN VHPT Nghề" },
    { value: 4, name: "Hoàn thành CT GDPT" },
]

export const HINH_THUC_NHAN = [
    { value: 2, name: "---Chọn---" },
    { value: 0, name: "Giấy báo trực tiếp" },
    { value: 1, name: "Gửi bưu điện" },
]

export const LOAI_HINH = [
    { value: 0, name: "Công lập trung ương" },
    { value: 1, name: "Công lập địa phương" },
    { value: 2, name: "Tư thục" },
    { value: 3, name: "Vốn đầu tư nước ngoài" },
    { value: 4, name: "Doanh nghiệp nhà nước" },
]

export const BUOI = [
    { value: 0, name: "Buổi sáng" },
    { value: 1, name: "Buổi trưa" }
]

export const TIET = [
    { value: 1, name: "Tiết 1" },
    { value: 2, name: "Tiết 2" },
    { value: 3, name: "Tiết 3" },
    { value: 4, name: "Tiết 4" },
    { value: 5, name: "Tiết 5" },
]

export const MESSAGE_TYPE = {
    "SUCCESS": "success_notification",
    "ERROR": "error_notification",
    "WARNING": "warning_notification"
}

export const KEY_LOCALSTORAGE = {
    LANGUAGE: "culture",
    LANGUAGE_DEFAULT: "vi",
    STATUS: "status"
}

export const AUTH = {
    TOKEN_KEY: 'access_token',
    USER_INFO_KEY: 'user',
    TOKEN_KEY_KEYCLOAK: 'access_token_keycloak',
    REFRESH_TOKEN_KEY_KEYCLOAK: 'refresh_token_keycloak',
    EXPIRES_IN: 'expires_in'
};

export const COPI_TYPE = [
    { id: 1, name: "NGUOI_CO_CONG.SEARCH.COPIES" },
    { id: 0, name: "NGUOI_CO_CONG.SEARCH.ORIGINALS" }
]

export const GENDER_TYPE = [
    { id: 1, name: "NGUOI_CO_CONG.SEARCH.MAN" },
    { id: 2, name: "NGUOI_CO_CONG.SEARCH.WOMAN" }
]

export const GENDER_GDNN = [
    { id: 1, name: "NGUOI_CO_CONG.SEARCH.MAN" },
    { id: 0, name: "NGUOI_CO_CONG.SEARCH.WOMAN" }
]

export const GENDER_NCC = [
    { id: 1, name: "NGUOI_CO_CONG.SEARCH.MAN" },
    { id: 0, name: "NGUOI_CO_CONG.SEARCH.WOMAN" },
    { id: 2, name: "Không xác định"}
]

export const TRAINING_SYSTEM_ID = {
    CAO_DANG: "ce187385-165f-453a-a301-e55ca75f6e81",
    TRUNG_CAP: "2b8d56da-0ce7-466a-83c9-01ec2c1646c5",
    SO_CAP: "41220623-55d3-40a7-aa85-4311f11d0644",
    NGAN_HAN: "c9edff78-2604-4029-aaf2-8650464b9ca8"
}

export const REPORT = {
    R001: "Danh sách người có công",
    R002: "Báo cáo tổng hợp"
}

export const WORSHIP = [
    { id: 1, name: "NGUOI_CO_CONG.DETAIL.INFO_PROFILE.YES" },
    { id: 2, name: "NGUOI_CO_CONG.DETAIL.INFO_PROFILE.NO" }
]

export const TOM_TYPE_LIST: any[] = [
    { id: 333, ten: "Mộ trống" },
    { id: 102, ten: "Mộ không có hài cốt" },
    { id: 257, ten: "Mộ có hài cốt" },
    { id: 331, ten: "Đã chuyển đi" },
    { id: 332, ten: "Mộ vọng" }
];

export const FILE_UPLOAD = {
    ACCEPT_PATTERN: {
        ANY: '(.*?).(pdf|xls|xlsx|doc|docx|png|gif|jpg|jpeg)$',
        IMAGE: '(.*?).(png|gif|jpg)$',
        DOCUMENT: '(.*?).(pdf|xls|xlsx|doc|docx)$',
        MS_WORD: '(.*?).(doc|docx)$',
        MS_EXCEL: '(.*?).(xls|xlsx)$',
        PDF: '(.*?).(pdf)$',
    },
    ACCEPT_SIZE: {
        MIN: 0,
        MAX_PERFILE_SCREEN13: 26214400,//Bytes ~ 25MB
        MAX: 10485760, //Bytes ~ 10MB
        MAX_TOTAL: 104857600 //Bytes ~ 100MB
    },
    MIMETYPE: {
        GIF: "image/gif",
        JPG: "image/jpeg",
        PNG: "image/png",
        PDF: "application/pdf",
        DOC: "application/msword",
        DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        XLS: "application/vnd.ms-excel",
        XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ZIP: "application/zip"
    }
}

export const DATE_PATTERN = {
    NORMAL: 'dd/MM/yyyy',
    SHORT: 'dd/MM/yy',
    NORMAL_WITH_TIME: 'dd/MM/yyyy HH:mm:ss',
    NORMAL_WITH_DATE_TIME: 'HH:mm:ss dd/MM/yyyy',
    NORMAL_WITH_SHORT_TIME: 'dd/MM/yyyy HH:mm',
    SHORT_WITH_TIME: 'dd/MM/yy HH:mm:ss',
    SHORT_WITH_SHORT_TIME: 'dd/MM/yy HH:mm',
    ONLY_YEAR: 'yyyy',
    ONLY_SHORT_YEAR: 'yy',
    ONLY_MONTH: 'MM',
    ONLY_DAY: 'dd',
    ONLY_SHORT_TIME: 'HH:mm',
    ONLY_TIME: 'HH:mm:ss',
    NORMAL_FORMAT: 'yyyy-MM-dd',
    MOMENT_FORMAT: 'YYYY-MM-DD',
    MOMENT_NORMAL: 'DD/MM/YYYY',
    DateFormat: 'yyyyMMddHHmmss',
    PERIOD: 'yyyyMM',
    DATE_FORMAT: 'dd-MM-yyyy',
    DATE_INTEGER: "yyyyMMdd",
    DATE_SIG: "yyyy/MM/dd",
    DATE: "ddMMyyyy",
    FORM_TO_YEAR: "yyyy-yyyy",
}

export const ALIVE_TYPE = [
    { id: 1, name: "NGUOI_CO_CONG.DETAIL.CAREFULLY.LIVE" },
    { id: 2, name: "NGUOI_CO_CONG.DETAIL.CAREFULLY.DIE" }
]

export const TOMB_MANAGER = [
    { id: 1, name: "NGUOI_CO_CONG.DETAIL.INFO_PROFILE.MARTYRST_CEMETERY" },
    { id: 2, name: "NGUOI_CO_CONG.DETAIL.INFO_PROFILE.FAMILY" }
]

export const isMobile = () => (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
export const isIOS = () => (/iphone|ipad|ipod/).test(navigator.userAgent.toLowerCase());

export const SALARY = [
    { id: 1, name: "NGUOI_CO_CONG.DETAIL.INFO_PROFILE.SALARY_OPTION" },
    { id: 2, name: "NGUOI_CO_CONG.DETAIL.INFO_PROFILE.SUBSISTENCE" }
]

export const NATION = [
    { id: 1, name: "NGUOI_CO_CONG.DETAIL.QD57.LAOS" },
    { id: 2, name: "NGUOI_CO_CONG.DETAIL.QD57.CAMPUCHIA" }
]

export const ACTION_TYPE = {
    ACCESS: 1,
    INPUT: 2,
    BUTTON: 3
}

export const GDNN_CSDT = {
    CDNNNB: "392bee4b-c33e-4b77-a80a-bea8ff46d7d5"
}

export const GDNN_REPORT = {
    HOC_VIEN: "Danh sách học viên"
}

export const LOG_ACTION = {
    VIEW: "View",
    INSERT: "Add",
    DELETE: "Delete",
    UPDATE: "Update",
    EDIT: "Edit",
    CORRECTIONS: "Corrections"
}

export const LOG_ACTION_LIST = [
    "View", "Add", "Delete", "Update", "Edit", 'Corrections'
]

export const BIRTHDAY_TYPE = [
    { id: 0, name: "Ngày sinh" },
    { id: 1, name: "Năm sinh" }
]

export const TRANG_THAI_THU_TRUONG = [
    { id: 'CON_LAM_VIEC', name: "Còn làm việc" },
    { id: 'NGHI_HUU', name: "Nghĩ hữu" }
]

export const KET_QUA_SAU_TN = [
    { id: 1, name: "Hộ thoát nghèo" },
    { id: 2, name: "Hộ trở thành hộ khác" }
]

export const MUC_SONG = [
    { id: "Khá giả", ten: "Khá giả" },
    { id: "Trung bình", ten: "Trung bình" },
    { id: "Cận nghèo", ten: "Cận nghèo" },
    { id: "Nghèo", ten: "Nghèo" }
]

export const NHA_O = [
    { id: 1, ten: "Tự xây" },
    { id: 2, ten: "Được cấp nhà tình nghĩa" },
    { id: 3, ten: "Được hỗ trợ tiền sửa chữa nhà ở" }
]

export const VAY_VON = [
    { id: 0, ten: "Đã được hỗ trợ" },
    { id: 1, ten: "Chưa được hỗ trợ" }
]

// AGG
export const BODY_TYPE = {
    FORM_DATA: 0,
    RAW_JSON: 1
};

export const COLOR_PALETTES = {
    RETRO_METRO: ["#ea5545", "#f46a9b", "#ef9b20", "#edbf33", "#ede15b", "#bdcf32", "#87bc45", "#27aeef", "#b33dc6"],
    DUTCH_FIELD: ["#e60049", "#0bb4ff", "#50e991", "#e6d800", "#9b19f5", "#ffa300", "#dc0ab4", "#b3d4ff", "#00bfa0"],
    RIVER_NIGHTS: ["#b30000", "#7c1158", "#4421af", "#1a53ff", "#0d88e6", "#00b7c7", "#5ad45a", "#8be04e", "#ebdc78"],
    SPRING_PASTELS: ["#fd7f6f", "#7eb0d5", "#b2e061", "#bd7ebe", "#ffb55a", "#ffee65", "#beb9db", "#fdcce5", "#8bd3c7"],
    PALETTE_1: ["#ef476f", "#ffd166", "#06d6a0", "#118ab2", "#073b4c"], // https://coolors.co/ef476f-ffd166-06d6a0-118ab2-073b4c
    PALETTE_2: ["#9b5de5", "#f15bb5", "#fee440", "#00bbf9", "#00f5d4"], // https://coolors.co/palette/9b5de5-f15bb5-fee440-00bbf9-00f5d4
    PALETTE_3: ["#ff595e", "#ffca3a", "#8ac926", "#1982c4", "#6a4c93"], // https://coolors.co/palette/ff595e-ffca3a-8ac926-1982c4-6a4c93
    PALETTE_4: ["#0E7CC6", "#E54242", "#ff9770", "#ffd670", "#e9ff70"], // https://coolors.co/70d6ff-ff70a6-ff9770-ffd670-e9ff70
    PALETTE_5: ["#bce784", "#5dd39e", "#348aa7", "#525174", "#513b56"], // https://coolors.co/bce784-5dd39e-348aa7-525174-513b56
    PALETTE_6: ["#0d1345", "#f1a26d", "#ff0916", "#fcdb06", "#9a0639", "#639f03", "#3c0008", "#f2f2f2"], // https://coolors.co/0d1345-f1a26d-ff0916-fcdb06-9a0639-639f03-3c0008-f2f2f2
    PALETTE_7: ["#F7A4A4", "#FEBE8C", "#FFFBC1", "#B6E2A1", "#2192FF", "#38E54D", "#9CFF2E", "#FDFF00"], // https://colorhunt.co/palette/f7a4a4febe8cfffbc1b6e2a1, https://colorhunt.co/palette/2192ff38e54d9cff2efdff00
    PALETTE_8: ["#D45E81", "#10BA6D", "#2B76AF", "#14A39C", "#B3651D"], // https://coolors.co/d45e81-10ba6d-2b76af-14a39c-b3651d
    PALETTE_9: ["#33AA12", "#EDE500", "#E24F1A", "#34D092", "#077AE7", "#EC1414"], // https://coolors.co/33aa12-e54242-ff9770-34d092-077ae7-ebff7d
    PALETTE_10: ["#33AA12", "#E54242", "#34D092", "#079DE8", "#EFC404", "#1ACED8", "#3C2EDB", "#E39696", "#E88D05", "#CBFA79", "#0729E8", "#05F0B1", "#1B7D54", "#E805B7", "#78FAE6", "#40616B", "#FF9770", "#A31AD9", "#FFEA00"],
    PALETTE_11: ["#D24768", "#D9B561", "#1FB58D", "#118AB2", "#8FC219", "#E1830F"], // https://coolors.co/d24768-d9b561-1fb58d-118ab2-8fc219-e1830f
    PALETTE_12: ["#33AA12", "#E54242", "#FF9770", "#34D092", "#077AE7", "#EBFF7D", "#40E609", "#E8CD1E"], // https://coolors.co/33aa12-e54242-ff9770-34d092-077ae7-ebff7d-40e609-e8cd1e
};
// END AGG


// minhvn.bte - 12/07/2022
export const TINHTRANG_VIECLAM = [
    { id: 0, name: "--Tất cả--" },
    { id: 1, name: "Có việc làm" },
    { id: 2, name: "Thất nghiệp" },
    { id: 3, name: "Không tham gia hoạt động kinh tế" }
]
// End minhvn.bte - 12/07/2022

// minhvn.bte -  IT5ASXH-5529 - 18/07/2022
export const TINH_TYPE = [
    { id: 1, name: "Trong tỉnh" },
    { id: 2, name: "Ngoại tỉnh" },
    { id: 3, name: "Ngoài nước" },
]

export const KIEU_HIENTHI = [
    { id: 1, name: "Dạng bảng" },
    // { id: 2, name: "Dạng biểu đồ, chart" },
]

export const BLACKLISTPASS = [
    'vnpt@123', 'vnpt@1234', 'vnpt@12345', 'vnpt@123456',
    'vnpt#123', 'vnpt#1234', 'vnpt#12345', 'vnpt#123456',
    'vpdt@123', 'vpdt@1234', 'vpdt@12345', 'vpdt@123456',
    'vpdt#123', 'vpdt#1234', 'vpdt#12345', 'vpdt#123456'
];

// End minhvn.bte -  IT5ASXH-5529 - 18/07/2022

export const strHuongDanNhapLieu = "- (1) Ghi số CCCD, trường hợp chưa có số CCCD thì ghi số CMND;<br>" +
    "- (2), (3) Ghi rõ theo thứ tự số nhà, đường phố, xóm, làng; thôn, ấp, bản, buôn, phum, sóc; xã/phường/thị trấn; quận/huyện/thị xã/thành phố thuộc tỉnh; tỉnh/thành phố trực thuộc trung ương;<br>" +
    "- (4) Ghi chi tiết tên gọi mã cấp III của giáo dục, đào tạo;<br>" +
    "- (5) Người có việc làm là người có làm bất cứ việc gì (không bị pháp luật cấm) để tạo ra các sản phẩm hàng hóa hoặc cung cấp các dịch vụ nhằm mục đích tạo thu nhập cho bản thân và gia đình;<br>" +
    "- (6) Người thất nghiệp là người đang không có việc làm, đang tìm kiếm việc làm và sẵn sàng làm việc;<br>" +
    "- (7) Ghi cụ thể tên công việc chiếm nhiều thời gian nhất và tạo ra thu nhập chính;<br>" +
    "- (8) Ghi tên, loại hình và địa chỉ cụ thể nơi đang làm việc;<br>" +
    "- STT 3, 7, 8, 9, 10, 11.1, 12: Đánh dấu X vào ☐ tương ứng với nội dung trả lời.";
// End minhvn.bte -  IT5ASXH-6215 - 13/09/2022
export const PATTERT_SYMBOL_NO = /^[^!"#$%&'()*+,-./:;<=>?@^_~`\[\{\]\}|?\\]+$/i;
export const PATTERT_PASSWORD_NO = /^[^ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹếẾ ]+$/i;
export const PATTERT_SYMBOL = /^[a-zA-Z_0123456789ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹếẾ:,@'()\n-;% ]+$/i;
export const PATTERT_CHAR = /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹếẾ:',; ]+$/i;
export const PATTERT_NUMBER = /^[0-9]+$/i;
export const PATTERT_FLOAT = /^(?!0\d)\d*(\.\d+)?$/;
export const PARTERT_PHONE_NUMBER = /((09|03|07|08|05)+([0-9]{8})\b)/g;
export const PARTERT_PHONENUMBER = /^(0|84)(\s|\.)?((2[0-9][0-9])|(3[2-9])|(5[689])|(7[06-9])|(8[01-689])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3})$/;
export const PATTERT_WITH_DOT = /^[a-zA-Z_0123456789ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹếẾ:',;.\- ]+$/i;
export const PATTERT_WITH_DOT_HGI = /^[a-zA-Z_0-9ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹếẾ:',;.\-()“”" ]+$/i;
export const PATTERT = /^[a-zA-Z_0123456789:,;/.\- ]+$/i;
export const PATTERT_PASSWORD = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&'()*+,-./:;<=>?@^_~]).{8,32}$/;
export const PATTERN_NO_UNICODE = /^(?=.*[!"#$%&'()*+,-./:;<=>?@^_~])(?=.*[abcdefghijklmnopqrstuvwxyz])(?=.*[ABCDEFGHIJKLMNOPQRSTUVWXYZ])(?=.*[abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ]).{8,32}$/;
// export const PATTERN_NO_UNICODE = /^(?=\S.*[!"#$%&'()+,-./:;<=>?@^_~])(?=\S.*[abcdefghijklmnopqrstuvwxyz])(?=.*[ABCDEFGHIJKLMNOPQRSTUVWXYZ])(?=.*[abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ])(.*\S){8,32}$/;
export const PATTERT_USERNAME = /^[a-zA-Z_0123456789._]+$/i;
export const PATTERT_EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const FORM_TO_YEAR = "yyyy-yyyy";
export const PATTERN_YEAR = /^((2|1){1}[0-9]{3})+$/i;
export const PATTERN_URL = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig;
export const PATTERN_DATE_BIRTH = /^([0-9]{4}|([0]?[1-9]|[1|2][0-9]|[3][0|1])[./-]([0]?[1-9]|[1][0-2])[./-]([0-9]{4}))$/;
export const PRTTERN_WEBSITE = /^(https|ftp|http|ftps):\/\/([a-z\d_]+\.)?(([a-zA-Z\d_]+)(\.[a-zA-Z]{2,6}))(\/[a-zA-Z\d_\%\-=\+]+)*(\?)?([a-zA-Z\d=_\+\%\-&\{\}\:]+)?/
export const PATTERT_CHAR_SEARCH = /^[a-zA-Z0-9_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹếẾ:',; ]+$/i;

export const PATTERN_BHXH = /^([0-9]){10}$/;
export const PATTERN_CMND = /^(?:[0-9]{9}|[A-Z][0-9]{7}|[0-9]{12}|[0-9]{12})$/;
export const PATTERN_PASSPORT = /^.{0,30}$/;
export const PATTERN_DDMMYYYY = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
export const PATTERN_SDT = /^(?:[0]9)?[0-9]{10}|(?:[0]9)?[0-9]{11}\$/;
export const PATTERN_MMYYYY = /^(([1-9])|(0[1-9])|(1[0-2]))\/((2009)|(20[1-2][0-9]))$/;

export const MAX_LENGTH = {
    PLACE: 255,
    MONEY: 11,
    NOTE: 500,
    CONTENT: 1000,
    DEFAULT: 100,
    QD_NUMBER: 50
}

export const ONLY_TEXT = /^[a-zA-Z_]+$/;

export const PATTERT_EMAIL_LDVL = /^[a-z0-9]+@[a-z0-9]+\.[a-z]+$/i;
export const PATTERT_PHONE_LDVL = /^(\+84|0)(\d){9}$/;
export const PATTERT_INTER_PHONE_LDVL = /^\+[0-9]{8,}$/;
export const PATTER_FILE_NUMBER = /^[a-zA-Z0-9\sÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ0-9]*$/;
export const PATTER_ADDRESS = /^[a-zA-Z\sÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ0-9,-/&.]*$/;
export const PATTERN_ID = /^([0-9]){12}$/;
export const PATTERN_PHONE = /^(0|084)(\s|\.)?([0-9]){9}$/;
export const PATTERN_DATE = /^\d{2}\/\d{2}\/\d{4}$/;
export const PATTERT_NUMBER_WITH_DOT = /^[0-9.]+$/i;
export const PATTER_WITH_SLASH = /^[a-zA-Z\sÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ0-9/.\-]*$/;
export const PATTERN_DATE_BIRTH_ONLY_S = /^([0-9]{4}|([0]?[1-9]|[1|2][0-9]|[3][0|1])[/]([0]?[1-9]|[1][0-2])[/]([0-9]{4}))$/;
export const PATTER_WITH_SLASH_P = /^[a-zA-Z\sÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ0-9/]*$/;
export const PATTERN_BHYT = /^([A-Z]{2})([1-5])(\d{2})(\d{10})$|^\d{10}$/;
export const PATTERN_MM_YYYY = /^(([1-9])|(0[1-9])|(1[0-2]))\/((2009)|(20[1-2][0-9]))$/;
export const PATTERN_MONEY = /^\d{0,13}(\.\d{0,2})?$/;
export const PATTERN_NEGATIVE_NUMBER = /^[-]?[0-9]+$/i;
export const PATTERN_NEGATIVE_REAL = /^[-]?(?!0\d)\d*(\.\d+)?$/;
export const PATTERN_FLOAT = /^(?!0\d)\d*(\.\d+)?$/;
export const PATTERN_YEAR_PICKER = /([0-9]{4})+$/i;
export const PATTERN_DATE2 = /^([1-2][0-9])|([1-9])|(3[0-1])+[/]+(1[0-2])|([1-9])+[/]+([0-9]{4})+$/i;
export const PATTERN_PHONENUMBER = /(0)+(((3[2-9]|5[6|8|9]|9[0-9]|8[0-9]|7[0|6-9])+([0-9]{7}))|((2[0-9])+([0-9]{8})))+$/i;
export const PATTERT_SOVB = /^[a-zA-Z0-9_\/.\- đĐưƯ ]+$/;
export const PATTERN_CHAR_HGI = /^[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỲỴÝỶỸ\s]*$/i;
export const PATTERN_GPLD_HGI = /^(?!\s)[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỲỴÝỶỸ0-9/-]+$/;
export const PATTERN_EMAIL_LDVL_HGI = /^[a-zA-Z0-9](?!.*[._-]{2})[a-zA-Z0-9._-]*[a-zA-Z0-9]@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/

export const PATTER_MANCC = /^[a-zA-Z0-9sÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ0-9 ]*$/;
export const PATTERT_HOTEN = /^[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹếẾ ]+$/i;
export const PATTERT_SYMBOL2 = /^[a-zA-Z0-9ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹếẾ:(),.@;&_\- \n ' "/]+$/i;
export const PATTER_NCC_HGI = /^[a-zA-Z0-9\sÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ0-9:(),.;&_\\ \-"/]*$/;

export const MESSAGE_SEVERITY = {
    DEFAULT: 0,
    INFO: 1, // blue
    SUCCESS: 2, // green
    WAIT: 3,
    ERROR: 4, // red
    WARNING: 5 // orange
};


export const PAGE_NUM = 0;
export const PAGE_SIZE = 10;
export const PATTER_BANK_ACCOUNT = /^\d{7,15}$/;

export const PATTERN_M_YYYY = /^(([1-9])|(1[0-2]))\/((2009)|(20[1-2][0-9]))$/;

// HGI
export function formatVND(amount: number): string {
    if (!amount && amount !== 0) {
        return '';
    }
    return amount.toLocaleString('vi-VN');
}

export function convertVNDToNumber(amount: string): number {
    const formattedAmount = amount.replace(/\./g, '').replace(',', '.');
    const number = parseFloat(formattedAmount);
    return isNaN(number) ? 0 : Math.round(number);
}
